import { FC } from 'react';
import { Button as AntdButton, ButtonProps, theme } from 'antd';
import cn from 'classnames';
import styles from './button.module.scss';

interface CustomVariantProps {
    variant?: 'primary' | 'secondary' | 'small';
}

type CustomButtonProps = Omit<ButtonProps, keyof CustomVariantProps> &
    CustomVariantProps;

const variantClassMap = {
    primary: styles.primary,
    secondary: styles.secondary,
    small: styles.small,
};

export const Button: FC<CustomButtonProps> = ({
    children,
    variant = 'primary',
    className,
    ...props
}) => {
    const { token } = theme.useToken();

    return (
        <AntdButton
            {...props}
            className={cn(styles.btn, variantClassMap[variant], className)}
        >
            {children}
        </AntdButton>
    );
};
